import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

const CalculatorModal = ({ isOpen, onClose, onSelectCalculatorType }) => {
    useEffect(() => {
        if (isOpen) {

            document.body.style.overflow = 'hidden';
            document.body.style.position = 'fixed';
            document.body.style.width = '100%';
            document.body.style.top = `-${window.scrollY}px`;
        } else {

            document.body.style.overflow = 'unset';
            document.body.style.position = '';
            document.body.style.width = '';
            const scrollY = document.body.style.top;
            document.body.style.top = '';
            window.scrollTo(0, parseInt(scrollY || '0') * -1);
        }


        return () => {
            document.body.style.overflow = 'unset';
            document.body.style.position = '';
            document.body.style.width = '';
            document.body.style.top = '';
        };
    }, [isOpen]);

    if (!isOpen) return null;

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    const calculatorTypes = [
        { id: 'absence', label: 'الغياب', description: 'حاسبة الغياب' },
        { id: 'gpa', label: 'المعدل التراكمي', description: 'حاسبة المعدل التراكمي' },
        { id: 'health', label: 'المسار الصحي', description: 'حاسبة المسار الصحي' },
        { id: 'percentage', label: 'تحويل المعدل إلى نسبة', description: 'حاسبة تحويل المعدل' },
        { id: 'weighted',   label: 'النسبة الموزونة',         description: 'حساب النسبة الموزونة' }

    ];

    const handleCalculatorSelection = (type) => {
        onSelectCalculatorType(type);
        onClose();
    };

    return createPortal(
        <div
            className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
            onClick={handleBackdropClick}
        >
            {             }
            <div className="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>

            {           }
            <div
                className="relative rounded-lg p-6 md:p-8 w-full max-w-md"
                dir="rtl"
                style={{
                    background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.02), rgba(255, 255, 255, 0.02)), radial-gradient(92.12% 184.55% at 50% -55%, rgba(40, 227, 218, 0.2) 0%, rgba(40, 227, 218, 0) 100%), #081423',
                    borderRadius: '8.61px'
                }}
            >
                {            }
                <div className="text-center mb-8">
                    <h2 className="text-2xl font-bold text-white mb-2">الحاسبة</h2>
                    <p className="text-[#D5D2D2] text-sm">اختر نوع الحاسبة</p>
                </div>

                {                             }
                <div className="space-y-4">
                    {calculatorTypes.map((type) => (
                        <button
                            key={type.id}
                            onClick={() => handleCalculatorSelection(type.id)}
                            className="w-full h-9 border border-white rounded-lg text-white hover:bg-white/10 transition-all duration-200 text-sm font-bold flex items-center justify-center"
                            style={{
                                padding: '6.46px',
                                fontSize: '12.92px',
                                lineHeight: '140%'
                            }}
                        >
                            {type.label}
                        </button>
                    ))}
                </div>

                {                  }
                <button
                    onClick={onClose}
                    className="absolute top-4 left-4 w-8 h-8 bg-[#14134A] rounded-lg flex items-center justify-center text-white hover:bg-[#1a1a5a] transition-colors"
                >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M18 6L6 18M6 6l12 12" />
                    </svg>
                </button>
            </div>
        </div>,
        document.body
    );
};

export default CalculatorModal;
